<div class="flex flex-column gap-8">
	<mat-label>{{ 'mes.administration.terminal.terminal-station' | translate }}</mat-label>
	<mat-select [value]="dataService.stationNumber" (selectionChange)="terminalStationSelectionChange($event)" [class.single-option]="stationOptions?.length === 1" [disabled]="!stationOptions || stationOptions.length == 1">
		@for (station of stationOptions; track station) {
			<mat-option [value]="station">
				{{ station }}
			</mat-option>
		}
	</mat-select>
</div>
